import { HttpClient, HttpHeaders } from '@angular/common/http';
import {Observable, of} from 'rxjs';
import {map, tap} from 'rxjs/operators';
import { PiensoApp } from '@platform/navigation/interfaces';


// export interface EndpointRoot {
//   endpointRoot: string;
// }

// export const ENDPOINT_ROOT = new InjectionToken<EndpointRoot>('API endpoint root');

// const ConfigServiceFactory = (http: HttpClient, endpointRoot: EndpointRoot) => new ConfigService(http, endpointRoot.endpointRoot);


export class ConfigService {

  protected readonly endpoint: string;

  protected cache = new Map<string, string>();

  constructor(protected http: HttpClient, protected endpointRoot: string) {
    this.endpoint = endpointRoot + '/config/';
  }

  httpOptions() {
    return {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };
  }

  getPiensoApps(): Observable<PiensoApp[]> {
    return this.get('pienso_apps').pipe(
      map(([s]) => s.replace(/[\"\[\]]/g, '').split(' '))
    ) as Observable<PiensoApp[]>;
  }

  // get(param: string): Observable<string> {
  //   const cached = this.cache.get(param);
  //   if (cached) {
  //     return of(cached);
  //   }
  //   return this.http.get(this.endpoint + param, {
  //     headers: {
  //       'Content-Type': 'text/plain'
  //     },
  //     responseType: 'text'
  //   })
  //     .pipe(
  //       tap(value => this.cache.set(param, value))
  //     );
  // }

  get(...params: string[]): Observable<string[]> {
    let hasAll = true;
    const cached: string[] = [];
    for (let i = 0; i < params.length; i++) {
      const v = this.cache.get(params[i]);
      if (!v) {
        hasAll = false;
        break;
      }
      cached.push(v);
    }
    if (hasAll) {
      return of(cached);
    }
    return this.http.get<string[]>(this.endpoint + params.join('+'), this.httpOptions())
      .pipe(
        tap(values => params.forEach((p, i) => { this.cache.set(p, values[i]); }))
      );
  }

}
